module.exports = __webpack_public_path__ + "img/36.b346ca8.jpg";